function cardType(value: string) {
    if (value.match(/^3[47][0-9]{13}$/)) {
        return 'amex'
    }
    if (value.match(/^3(?:0[0-5]|[68][0-9])[0-9]{11}$/)) {
        return 'dinersclub'
    }
    if (value.match(/^4[0-9]{12}(?:[0-9]{3})?$/)) {
        return 'visa'
    }
    if (value.match(/^5[1-5][0-9]{14}$|^2(?:2(?:2[1-9]|[3-9][0-9])|[3-6][0-9][0-9]|7(?:[01][0-9]|20))[0-9]{12}$/)) {
        return 'master'
    }
    if (value.match(/^65[4-9][0-9]{13}|64[4-9][0-9]{13}|6011[0-9]{12}|(622(?:12[6-9]|1[3-9][0-9]|[2-8][0-9][0-9]|9[01][0-9]|92[0-5])[0-9]{10})$/)) {
        return 'discover'
    }
    if (value.match(/^(?:2131|1800|35[0-9]{3})[0-9]{11}$/)) {
        return 'jcb'
    }
    return ''
}

function clearNumber(value = '') {
    return value.replace(/\D+/g, '')
}

export function formatCreditCardNumber(value: string) {
    if (!value) {
        return value
    }

    const clearValue = clearNumber(value)
    const issuer = cardType(clearValue)
    let nextValue

    switch (issuer) {
        case 'amex':
            nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(4, 10)} ${clearValue.slice(10, 15)}`
            break
        case 'dinersclub':
            nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(4, 10)} ${clearValue.slice(10, 14)}`
            break
        case 'master':
        case 'discover':
        case 'jcb':
            nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(4, 8)} ${clearValue.slice(8, 12)} ${clearValue.slice(12, 16)}`
            break
        default:    // other unknown formats
            nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(4, 8)} ${clearValue.slice(8, 12)} ${clearValue.slice(12, 19)}`
            break
    }

    return nextValue.trim()
}

export function formatCVC(value: string) {
    const clearValue = clearNumber(value)
    let max_length = 4
    return clearValue.slice(0, max_length)
}

export function formatExpirationDate(value: string) {
    const clearValue = clearNumber(value)

    if (clearValue.length >= 3) {
        return `${clearValue.slice(0, 2)}/${clearValue.slice(2, 6)}`
    }

    return clearValue
}

export function validateExpirationDate(value: string) {
    const month = parseInt(value.slice(0,2))
    if (month < 1 || month > 12) {
        return false
    }

    const year = parseInt(value.slice(3,7))
    if (new Date(year, month, 0) < new Date()) {
        return false
    }

    return true
}
